import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavEntryPoint } from '@retailer-platform/dashboard/routing'
import { connectOrdersRouter } from './routing/connectOrdersRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { connectOrdersAccessControl } from './access-control/connectOrdersAccess.configuration'
import { Permission } from './access-control/permissions'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'connect-orders',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'connect-orders-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {
    ES_ES: () => import('./translations/es-ES.json'),
    FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    scoped: [connectOrdersRouter],
  },
  navigationEntries: [
    {
      attachToV2: NavEntryPoint.OperationsCustomerSupport,
      subNavItems: [
        {
          type: 'item',
          llmDescription: 'Manage and view last-mile delivery orders from delivery partners',
          labelId: 'connectOrdersDomain.orderDetails.lastmiledelivery.title',
          route: 'connect-orders-orders-table',
          accessControl: connectOrdersAccessControl,
          positionNavV2: 2,
          inToolPermissions: [
            {
              slug: Permission.ConnectOrdersModify,
              permissionLabelId:
                'permissionAccordion.permissions.' + Permission.ConnectOrdersModify,
            },
            {
              slug: Permission.RetailersV4View,
              permissionLabelId: 'permissionAccordion.permissions.' + Permission.RetailersV4View,
            },
          ],
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
